import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";
import { formatDate } from "../utils/dateUtils";
import { formatStatus } from "../../../uteis/statusFormatted";

// Função para buscar as reservas

export const reservaService = async () => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/reserva`;

    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });
      const reservasArray = response.data.map((p: any) => {
        // Formatação de Dados
        const formattedCheckIn = formatDate(
          new Date(p.PeriodoUsuario?.PeriodoTable?.checkIn)
        );
        const formattedCheckOut = formatDate(
          new Date(p.PeriodoUsuario?.PeriodoTable?.checkOut)
        );
        const formattedLocacao = formatDate(new Date(p.dataLocacao));
        const formattedStatus = formatStatus(p.statusReserva);
        //------------------------------------------------------------\\
        return {
          key: p.id,
          id: p.id,
          cotaUsuario: p.PeriodoUsuario?.CotasUsuariosTable?.id,
          proprietarioId: p.PeriodoUsuario?.CotasUsuariosTable?.usuarioId,
          nomeEmpreendimento:
            p.PeriodoUsuario?.CotasUsuariosTable?.CotaTable?.AptoTable
              ?.EmpreendimentoTable?.nome,

          statusReserva: formattedStatus,
          checkIn: formattedCheckIn,
          checkOut: formattedCheckOut,
          dataLocacao: formattedLocacao,
          canal: p.canal,
          periodoUsuarioId: p.PeriodoUsuario?.id,
        };
      });

      return reservasArray; // Agora retorna o array processado
    } catch (error) {
      console.log(error);
    }
  }
  return []; // Retorna um array vazio se o Token não for válido
};

export {};
